var crypto = require('crypto');

const cryto = {
    //암호화
    SHAencode : function(content) {    
        return crypto.createHash('sha512').update(content).digest('base64'); // 'dvfV6nyLRRt3NxKSlTHOkkEGgqW2HRtfu19Ou/psUXvwlebbXCboxIPmDYOFRIpqav2eUTBFuHaZri5x+usy1g=='    
    }
}

export default cryto;